import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';


const CompanyCounters = ({ lastMonthTotal, currentMonthTotal }) => {
  return (
    <div className='d-inline-block text-left'>
      <label className='d-block'>
        <span className={styles.label}>Last Month Counter Total: </span>
        <span>{`${lastMonthTotal}`}</span>
      </label>
      <label className='d-block'>
        <span className={styles.label}>Current Month Counter Total: </span>
        <span>{`${currentMonthTotal}`}</span>
      </label>
    </div>
  );
};

CompanyCounters.propTypes = {
  lastMonthTotal: PropTypes.number,
  currentMonthTotal: PropTypes.number
};

export default CompanyCounters;


// WEBPACK FOOTER //
// src/components/companyDetails/CompanyCounters/index.jsx